import { RouterProvider } from "react-router-dom";

import { ErrorBoundary } from "@datadog/browser-rum-react";

import CssBaseline from "@mui/material/CssBaseline";
import ThemeProvider from "@mui/material/styles/ThemeProvider";
import { ToastContainer } from "react-toastify";

import { theme } from "@covertree/theme";
import { ErrorFallback } from "@covertree/ui";
import { WebTrackerProvider } from "@covertree/web-tracker";

import { router } from "@routing/router";
import { ApolloProvider } from "@apollo/client";
import { client } from "@apolloClient/client";
import environment from "@environment/variables";
import { featureFlags } from "@utils/featureFlags";

export default function App() {
  return (
    <ErrorBoundary fallback={ErrorFallback}>
      <WebTrackerProvider
        apiKey={environment.posthog.apiKey}
        apiHost={environment.posthog.apiHost}
        featureEnabled={featureFlags.enableWebTracking.isEnabled()}>
        <ToastContainer hideProgressBar />
        <ApolloProvider client={client}>
          <ThemeProvider theme={theme}>
            <CssBaseline />
            <RouterProvider router={router} />
          </ThemeProvider>
        </ApolloProvider>
      </WebTrackerProvider>
    </ErrorBoundary>
  );
}
